import authRules from '../authRules';

const addAssignmentEditAssignmentStatus = (user) => {
  const { assignmentStatus } = user.securityLevels;
  if (assignmentStatus >= authRules.addAssignmentEditAssignmentStatus.assignmentStatus) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditAssignmentStatus;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentEditAssignmentStatus.js